import * as React from 'react';
import { PageStackMobile } from './PageStackMobile';
import { PageStack } from './PageStack';
import { useSelector } from 'hooks/useSelector';
import { selectHasSidebarNavigation } from 'store/app/selectors';

export const PageMain: React.FC = () => {
  const hasSidebarNavigation = useSelector(selectHasSidebarNavigation);
  return hasSidebarNavigation ? <PageStack /> : <PageStackMobile />;
};
